<template>
  <div class="game-controls">
    <button class="control-btn restart" @click="store.restart">🔄 Restart</button>
  </div>
</template>

<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore';

const store = useGameStore();
</script>

<style scoped>
.game-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
}

.control-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
}

.control-btn.restart {
  background: linear-gradient(45deg, #ffaa00, #ff8800);
  color: #000;
}

.control-btn.restart:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 170, 0, 0.3);
}
</style>